import React, { useEffect, useState } from "react";
import { Menu, Search } from "lucide-react";

import { useNavigate, useParams } from "react-router-dom";
import { useStorage } from "../../../hooks/useLocalStorage";
import { getData } from "../../../api/api";

export default function Detail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [retreat, setRetreat] = useState({});
  useEffect(() => {
    getData(`/retreats/${id}`)
      .then((e) => {
        console.log(e.data);
        setRetreat(e.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <div className="relative h-[400px] bg-gradient-to-r from-cyan-900 to-blue-900 text-white">
        <header className="absolute top-0 left-0 right-0 z-10 flex justify-center items-center p-4"></header>

        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url("${
              retreat.retreatImages && retreat.retreatImages[0]?.url
            }")`,
          }}
        ></div>

        {/* <div className="relative flex justify-end  items-center  h-full ">
          <div className="relative z-10 flex  flex-col justify-center items-start h-full px-8 max-w-3xl">
            <div className="bg-black bg-opacity-50 p-6 rounded-lg">
              <h1 className="text-4xl md:text-6xl font-bold mb-4 text-yellow-400">
                {retreat.name}
              </h1>
              <p className="text-lg mb-6">
                <div
                  className="uploaded-content line-clamp-3"
                  dangerouslySetInnerHTML={{ __html: retreat.description }}
                />
              </p>
            </div>
          </div>
        </div> */}
      </div>

      <div className="font-sans max-w-7xl mx-auto p-6">
        <div className="   ">
          <div className="bg-gray-100 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mt-6 mb-2">
            {retreat.name}
            </h3>
            <h3 className="text-xl font-semibold mt-6 mb-2">
              Prices: ${retreat.cost}
            </h3>
            <p className="text-gray-700 mb-4">Scholarships are available</p>

            <h3 className="text-xl font-semibold mb-2">
              Dates for next course:
            </h3>
            <p className="text-gray-700 mb-2">Start Date:{retreat.startDate}</p>
            <p className="text-gray-700 mb-6">End Date: {retreat.endDate}</p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-8">
          <div className="">
            <h1 className="text-3xl font-semibold mb-6">{retreat.name}</h1>
            <div
              className="uploaded-content "
              dangerouslySetInnerHTML={{ __html: retreat.description }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
